module.exports = __webpack_public_path__ + "media/img/google-play-3cf6d4ec4d8f2585956ada1fb64573f7.svg";